import React, {useCallback} from 'react';

import b_ from 'b_';

import SurveyCardSkeleton from 'client/quicksurvey/list/components/survey-card-skeleton';
import SurveyItemButton from 'client/quicksurvey/list/components/survey-item-button';
import SurveyItemMenu from 'client/quicksurvey/list/components/survey-item-menu';
import SurveyState from 'client/common/components/survey-state';

import {SurveysGoal} from 'client/common/types';

import {formatDate} from 'client/common/utils/format';
import {AudienceTargeting} from 'client/common/utils/audience';
import {genSurveyLink} from 'client/common/utils/survey-link';
import I18N from 'assets/i18n/brandlift-project';

import {isSurveyItem} from 'client/common/store/reducers/surveys/types';

import {ComponentProps} from './types';

import './survey-card.css';

const i18n = I18N.list.surveyList;
const b = b_.with('survey-card');

export default function SurveyCard(props: ComponentProps) {
    const {categories, interests, segments, sendGoals, survey, isSuper} = props;

    const openCallback = useCallback(() => {
        sendGoals([SurveysGoal.ClickConstructorCard]);
    }, [sendGoals]);

    if (survey.isLoading || !isSurveyItem(survey)) {
        return <SurveyCardSkeleton />;
    }

    const {
        audience,
        moderationVerdict,
        name,
        paymentStatus,
        slug,
        state,
        surveyType,
        updatedAt
    } = survey;
    const targeting = AudienceTargeting.formatAsString({request: audience, categories, interests, segments});

    return (
        <div className={b()}>
            <a
                className={b('info')}
                onClick={openCallback}
                href={genSurveyLink({slug, surveyType})}
            >
                <div className={b('meta')}>
                    <SurveyState
                        className={b('state')}
                        state={state}
                        verdict={moderationVerdict}
                        isSuper={isSuper}
                        paymentStatus={paymentStatus}
                        type='text'
                        bullet
                    />
                    <span className={b('updated-at')} title={i18n.updatedAtTooltip}>
                        {formatDate(updatedAt)}
                    </span>
                </div>
                <span className={b('targeting')} title={targeting}>
                    {targeting}
                </span>
                <span className={b('name')} title={name}>
                    {name}
                </span>
            </a>
            <div className={b('actions')}>
                <SurveyItemButton {...survey} />
                <SurveyItemMenu {...survey} />
            </div>
        </div>
    );
}
